import './kitStyles';
import { useEffect, useState } from 'react';

/**
 * WEB-3310 юнит 2а-1 — плавное закрытие всплывающего (эталон: копия-«призрак»
 * `[data-ghost]` с анимацией `w2a-out`, 150–200 мс). По решению оркестратора
 * 23.10 — состоянием самого компонента, без вставки чужого узла в дерево React:
 * после закрытия узел остаётся смонтированным `GHOST_MS` с признаком `ghost`
 * (компонент ставит `data-ghost` и `aria-hidden`), потом снимается; при
 * `prefers-reduced-motion: reduce` — сразу.
 */
export const GHOST_MS = 150;

const reduced = () =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  !!window.matchMedia('(prefers-reduced-motion: reduce)')?.matches;

export function useGhost(open: boolean, ms: number = GHOST_MS): { shown: boolean; ghost: boolean } {
  const [shown, setShown] = useState(open);
  if (open && !shown) setShown(true);
  if (!open && shown && reduced()) setShown(false);
  useEffect(() => {
    if (open || !shown) return undefined;
    const t = setTimeout(() => setShown(false), ms);
    return () => clearTimeout(t);
  }, [open, shown, ms]);
  return { shown: open || shown, ghost: !open && shown };
}
